export default {
      id: "i-advantage2-usage",
      viewBox: "0 0 49 37",
      url: __webpack_public_path__ + "img/sprite.svg#i-advantage2",
      toString: function () {
        return this.url;
      }
    }